///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const OpenFullScreenIcon = ({
  height,
  width,
  title = messages.openFullScreen.defaultMessage,
  fill = "#000"
}) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="open-fullscreen"
  >
    <title id="openFullScreen-icon">{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h18v18H0z" />
      <path
        fill={fill}
        fillRule="nonzero"
        d="M15.75 8.25v-6h-6l2.4675 2.4675-7.5 7.5L2.25 9.75v6h6l-2.4675-2.4675 7.5-7.5z"
      />
    </g>
  </svg>
);

export default OpenFullScreenIcon;
